import styled from 'styled-components'

const Input = styled.input`
    border: 1px solid #2196f3; 
    padding: 1em; 
    width: 100%; 
`; 

export default Input 